import React from 'react';

export const CustomCard = ({ title, value, icon }) => {
  return (
    <div className="card bg-gray-50 shadow-lg p-4">
      <div className="flex items-start justify-between space-x-3">
        <div className="space-y-1">
          <span className="text-sm text-gray-500 uppercase">{title}</span>
          <h4 className="text-2xl font-bold text-blue-700">{value}</h4>
        </div>
        <div className="avatar">
          <div className="bg-primary rounded-full w-14 h-14 flex items-center justify-center">
            {icon}
          </div>
        </div>
      </div>
    </div>
  );
};
